import React, { useMemo } from 'react';
import styled from '@emotion/styled';

import { useEditor } from '../../hooks/useEditor';
import { findAncestorNodes, findNode, setNode } from '../../utils/node';

export function Inspector(): React.ReactElement | null {
  const { state, setState, components } = useEditor();
  const { document, cursor } = state;
  const node = findNode(document, cursor);
  const parents = findAncestorNodes(document, cursor).map(
    ({ children, props, parents, ...others }) => ({ ...others, props: {}, children: [] }),
  );

  const component = node != null ? components[node.type] : null;
  const child = useMemo(
    () => component != null &&
      node != null &&
      component.renderInspector != null &&
      component.renderInspector({
        value: {
          key: node.key,
          type: node.type,
          parents,
          props: { ...component?.defaultProps, ...node.props },
          children: node.children,
        },
        onChange: (value) => {
          setState((prevState) => ({
            ...prevState,
            document: setNode(prevState.document, cursor, value),
          }));
        },
      }),
    [component, node, cursor, setState],
  );
  if (node == null) {
    return null;
  }
  return <Container key={node.key}>{ child }</Container>;
}

const Container = styled.div`
  user-select: none;
`;
